<template>
  <v-flex xs6 md3>
    <router-link :to="`/gramatica/${urlIds}/gramaticaDash`" class="e-unitCard--link">
      <v-card class="e-cardGramaticaComplete e-elevation--4 e-border--radius">
        <v-card-title class="yellow text-xs-center pa-0 justify-center align-center d-flex">
          <img src="../../assets/images/unit/checkGramatica.svg" height="64">
        </v-card-title>
        <v-card-text >
          <h4 class="e-subTitle yellow--text text-xs-center mb-2"> {{ titulo }}</h4>
          <p class="e-description-regular mb-0 text-xs-center secondary--text">{{ descripcion }}</p>
        </v-card-text>
      </v-card>
    </router-link>
  </v-flex>
</template>

<script>
export default {
  props: {
    router: {
      type: String,
      default: ''
    },
    numero: {
      type: Number,
      default: 1
    },
    descripcion: {
      type: String,
      default: ''
    },
    urlIds: {
      type: String,
      default: ''
    },
    titulo: {
      type: String,
      default: ''
    }
  }
}
</script>